/**
 * Rounds the number to the nearest multiple of
 *
 * @param num - The number
 * @param multiple - The multiple to round to
 * @returns the rounded value
 */
export function roundToNearest(num: number, multiple: number): number {
    return Math.round(num / multiple) * multiple;
}
